import HeroSection from './HeroSection';
import BusinessSection from './BusinessSection';
import NumberSection from './NumberSection';
import ChooseUsSection from './ChooseUsSection';
import FaqSection from './FaqSection';
import React from 'react'; 

const Homepage = () => {
    const scrollToForm = () => {
        const target = document.getElementById('homepage-hero-card');
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <div>
            <HeroSection onScrollToForm={scrollToForm} />
            <NumberSection />
            <BusinessSection />
            <ChooseUsSection onScrollToForm={scrollToForm} />
            <FaqSection />
        </div>
    );
};

export default Homepage;